import i18n from '@/i18n';

const dialogChildren = [
  {
    path: 'new',
    name: 'users-new',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'user',
          actions: ['store'],
        },
      ],
      title: i18n.global.t('users'),
    },
    component: () => import('../../views/users/AddNew.vue'),
  },
  {
    path: ':id(\\d+)',
    name: 'users-edit',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'user',
          actions: ['update'],
        },
      ],
      title: i18n.global.t('users'),
    },
    component: () => import('../../views/users/Edit.vue'),
  },
];

export default [
  {
    path: '/users',
    name: 'users',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'user',
          actions: ['view-nav-link', 'view'],
        },
      ],
      title: i18n.global.t('users')
    },
    // route level code-splitting
    component: () => import('../../views/users/Index.vue'),
    children: dialogChildren,
  },
  {
    path: '/users/pending',
    name: 'users-pending',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'user',
          actions: ['view-nav-link', 'view'],
        },
      ],
      title: i18n.global.t('pending_users')
    },
    // route level code-splitting
    component: () =>
      import('../../views/users/Pending'),
    children: [
      {
        ...dialogChildren[0],
        name: 'pending-users-new',
      },
      {
        ...dialogChildren[1],
        name: 'pending-users-edit',
      },
    ],
  },
  {
    path: '/users/:id(\\d+)/settings',
    name: 'user-settings',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'user',
          actions: ['see-profile-settings'],
        },
      ],
      title: i18n.global.t('user_settings')
    },
    // route level code-splitting
    component: () =>
      import('../../views/users/Settings'),
  },
];
